angular.module('samcart').constant('Context', {
    store: window.context
});
